import React, {useState} from 'react';
import {Col, Row, DatePicker, Checkbox} from 'antd';
import InputField from '../../../../input-field';
import DividerBlock from "../../../../divider-block";
import SelectField from "../../../../select-field";
import FieldBlock from "../../../../field-block";
import RadioField from "../../../../radio-field";
import i18n from "../../../../../i18n";

export default function MainDataFields({
                                           stepFields, setFields, getFieldErrors, isProprietor,
                                           edit = false, defAdditionalRequisitesType = 'fill_registration_number'
}) {
    const [notRegisteredATI, setNotRegisteredATI] = useState(false);
    const [additionalRequisitesType, setAdditionalRequisitesType] = useState(defAdditionalRequisitesType);

    let dividerStyle = {
        margin: "15px 0px 45px 0px",
        display: "block",
        clear: "both",
        width: "100%",
        minWidth: "100%",
        height: "1px",
    };

    const firstToUpper = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    const renderAdditionalRequisites = () => {
        if (!isProprietor) {
            return null;
        }

        const addParamsTypes = [
            {id: 'fill_registration_number', name: i18n.t('modals.modalCreateNewLegalEntity.addParamsTypes.fillRegistrationNumber')},
            {id: 'fill_certificate', name: i18n.t('modals.modalCreateNewLegalEntity.addParamsTypes.fillCertificate')},
        ];

        const radio = (
            <RadioField
                values={addParamsTypes}
                onChange={(value) => setAdditionalRequisitesType(value.target.value)}
                selectedValue={additionalRequisitesType}
                getErrors={getFieldErrors}
            />
        );

        let additionalRequisitesForm = null;
        if (additionalRequisitesType === 'fill_registration_number') {
            additionalRequisitesForm = (
                <Col lg={8} md={8} sm={24} xs={24}>
                    <InputField
                        name="registrationNumber"
                        title={i18n.t('modals.modalCreateNewLegalEntity.fields.registrationNumber.title')}
                        label={i18n.t('modals.modalCreateNewLegalEntity.fields.registrationNumber.title')}
                        required={true}
                        value={stepFields.registrationNumber}
                        style={{marginLeft: '0px'}}
                        setValue={(value) => {
                            setFields({ ...stepFields, registrationNumber: value });
                        }}
                        getFieldErrors={getFieldErrors}
                    />
                </Col>
            );
        } else if (additionalRequisitesType === 'fill_certificate') {
            additionalRequisitesForm = (
               <>
                   <Col lg={6} md={6} sm={24} xs={24}>
                       <InputField
                           name="certificateSerial"
                           title={i18n.t('modals.modalCreateNewLegalEntity.fields.certificateSerial.title')}
                           label={i18n.t('modals.modalCreateNewLegalEntity.fields.certificateSerial.title')}
                           required={true}
                           value={stepFields.certificateSerial}
                           setValue={(value) => {
                               setFields({ ...stepFields, certificateSerial: value });
                           }}
                           getFieldErrors={getFieldErrors}
                       />
                   </Col>
                   <Col lg={8} md={8} sm={24} xs={24}>
                       <InputField
                           name="certificateNumber"
                           title={i18n.t('modals.modalCreateNewLegalEntity.fields.certificateNumber.title')}
                           label={i18n.t('modals.modalCreateNewLegalEntity.fields.certificateNumber.title')}
                           required={true}
                           value={stepFields.certificateNumber}
                           setValue={(value) => {
                               setFields({ ...stepFields, certificateNumber: value });
                           }}
                           getFieldErrors={getFieldErrors}
                       />
                   </Col>
               </>
            );
        }

        return (
            <Row gutter={[{ xs: 0, sm: 0, md: 16},16]}>
                <Col lg={24} md={24} sm={24} xs={24}>
                    {radio}
                </Col>
                {additionalRequisitesForm}
            </Row>
        );
    };

    return (
        <>
            <Row gutter={[{ xs: 0, sm: 0, md: 16},16]}>
                <Col lg={8} md={8} sm={24} xs={24}>
                    <InputField
                        name="name"
                        title={i18n.t('modals.modalCreateNewLegalEntity.fields.name.title')}
                        label={i18n.t('modals.modalCreateNewLegalEntity.fields.name.title')}
                        required={true}
                        value={stepFields.name}
                        setValue={(value) => {
                            setFields({ ...stepFields, name: value });
                        }}
                        getFieldErrors={getFieldErrors}
                    />
                </Col>
            </Row>
            <Row gutter={[{ xs: 0, sm: 0, md: 16},16]}>
                {isProprietor ? (
                    <Col lg={8} md={8} sm={24} xs={24}>
                        <InputField
                            name="iin"
                            title={i18n.t('modals.modalCreateNewLegalEntity.fields.iin.title')}
                            label={i18n.t('modals.modalCreateNewLegalEntity.fields.iin.title')}
                            required={true}
                            value={stepFields.iin}
                            setValue={(value) => {
                                setFields({ ...stepFields, iin: value });
                            }}
                            getFieldErrors={getFieldErrors}
                        />
                    </Col>
                ) : (
                    <Col lg={8} md={8} sm={24} xs={24}>
                        <InputField
                            name="bin"
                            title={i18n.t('modals.modalCreateNewLegalEntity.fields.bin.title')}
                            label={i18n.t('modals.modalCreateNewLegalEntity.fields.bin.title')}
                            required={true}
                            value={stepFields.bin}
                            setValue={(value) => {
                                setFields({ ...stepFields, bin: value });
                            }}
                            getFieldErrors={getFieldErrors}
                        />
                    </Col>
                )}
                <Col lg={8} sm={24} xs={24}>
                    <FieldBlock name="dateRegistration" title={i18n.t('modals.modalCreateNewLegalEntity.fields.dateRegistration.title')} getErrors={getFieldErrors}>
                        <DatePicker
                            style={{ width: "100%" }}
                            value={stepFields.dateRegistration}
                            defaultValue={stepFields.dateRegistration}
                            format="DD.MM.YYYY"
                            size="large"
                            name="dateRegistration"
                            onChange={value => setFields({...stepFields, dateRegistration:  value})}
                        />
                    </FieldBlock>
                </Col>
            </Row>

            <span className="divider-label">{i18n.t('modals.modalCreateNewLegalEntity.divider.contacts2')}</span>
            <DividerBlock style={dividerStyle} />

            <Row gutter={[{ xs: 0, sm: 0, md: 16}, 24]}>
                <Col lg={8} md={8} sm={24} xs={24}>
                    <InputField
                        name="firstName"
                        title={i18n.t('modals.modalCreateNewLegalEntity.fields.firstName.title')}
                        label={i18n.t('modals.modalCreateNewLegalEntity.fields.firstName.title')}
                        required={true}
                        value={stepFields.firstName}
                        setValue={(value) => {
                            setFields({ ...stepFields, firstName: firstToUpper(value) });
                        }}
                        getFieldErrors={getFieldErrors}
                    />
                </Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                    <InputField
                        name="secondName"
                        title={i18n.t('modals.modalCreateNewLegalEntity.fields.secondName.title')}
                        label={i18n.t('modals.modalCreateNewLegalEntity.fields.secondName.title')}
                        required={true}
                        value={stepFields.secondName}
                        setValue={(value) => {
                            setFields({ ...stepFields, secondName: firstToUpper(value) });
                        }}
                        getFieldErrors={getFieldErrors}
                    />
                </Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                    <InputField
                        name="patronymic"
                        title={i18n.t('modals.modalCreateNewLegalEntity.fields.patronymic.title')}
                        label={i18n.t('modals.modalCreateNewLegalEntity.fields.patronymic.title')}
                        required={true}
                        value={stepFields.patronymic}
                        setValue={(value) => {
                            setFields({ ...stepFields, patronymic: firstToUpper(value) });
                        }}
                        getFieldErrors={getFieldErrors}
                    />
                </Col>
            </Row>
            <Row gutter={[{ xs: 0, sm: 0, md: 16}, 24]}>
                {isProprietor ? (
                    <>
                        <Col lg={8} md={8} sm={24} xs={24}>
                            <InputField
                                name="legalReason"
                                isDisabled={true}
                                label={i18n.t('modals.modalCreateNewLegalEntity.fields.legalReason.title')}
                                value={i18n.t('modals.modalCreateNewLegalEntity.fields.legalReason.value')}
                                setValue={(value) =>
                                    setFields({ ...stepFields, legalReason: value })
                                }
                                getFieldErrors={getFieldErrors}
                            />
                        </Col>
                    </>
                ) : (
                    <>
                        <Col lg={8} md={8} sm={24} xs={24}>
                            <InputField
                                name="position"
                                label={i18n.t('modals.modalCreateNewLegalEntity.fields.position.title')}
                                value={stepFields.position}
                                setValue={(value) =>
                                    setFields({ ...stepFields, position: firstToUpper(value) })
                                }
                                getFieldErrors={getFieldErrors}
                            />
                        </Col>
                        <Col lg={8} md={8} sm={24} xs={24}>
                            <SelectField
                                title={i18n.t('modals.modalCreateNewLegalEntity.fields.legalReason.title')}
                                name="legalReason"
                                selectedValue={stepFields.legalReason}
                                values={stepFields.legalReasonsList}
                                onChange={(value) => {
                                    setFields({
                                        ...stepFields,
                                        legalReason: value,
                                    });
                                }}
                                getErrors={getFieldErrors}
                                placeholder={i18n.t('modals.modalCreateNewLegalEntity.fields.legalReason.placeholder')}
                                notFoundText={null}
                                showArrow={true}
                                style={{ width: "100%" }}
                            />
                        </Col>
                    </>
                )}
            </Row>

            <span className="divider-label">{i18n.t('modals.modalCreateNewLegalEntity.divider.bank2')}</span>
            <DividerBlock style={dividerStyle} />

            <Row gutter={[{ xs: 0, sm: 0, md: 16}, 24]}>
                <Col lg={8} md={8} sm={24} xs={24}>
                    <InputField
                        name="bankName"
                        title={i18n.t('modals.modalCreateNewLegalEntity.fields.bankName.title')}
                        label={i18n.t('modals.modalCreateNewLegalEntity.fields.bankName.title')}
                        required={true}
                        value={stepFields.bankName}
                        setValue={(value) => {
                            setFields({ ...stepFields, bankName: value });
                        }}
                        getFieldErrors={getFieldErrors}
                    />
                </Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                    <InputField
                        name="rs"
                        title={i18n.t('modals.modalCreateNewLegalEntity.fields.accountNumber.title')}
                        label={i18n.t('modals.modalCreateNewLegalEntity.fields.accountNumber.title')}
                        required={true}
                        value={stepFields.rs}
                        setValue={(value) => {
                            setFields({ ...stepFields, rs: value });
                        }}
                        getFieldErrors={getFieldErrors}
                    />
                </Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                    <InputField
                        name="bic"
                        label={i18n.t('modals.modalCreateNewLegalEntity.fields.bic.title')}
                        title={i18n.t('modals.modalCreateNewLegalEntity.fields.bic.title')}
                        required={true}
                        value={stepFields.bic}
                        setValue={(value) => {
                            setFields({ ...stepFields, bic: value });
                        }}
                        getFieldErrors={getFieldErrors}
                    />
                </Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                    <InputField
                        name="iik"
                        label={i18n.t('modals.modalCreateNewLegalEntity.fields.iik.title')}
                        title={i18n.t('modals.modalCreateNewLegalEntity.fields.iik.title')}
                        required={true}
                        value={stepFields.iik}
                        setValue={(value) => {
                            setFields({ ...stepFields, iik: value });
                        }}
                        getFieldErrors={getFieldErrors}
                    />
                </Col>
                <Col lg={24} md={24} sm={24} xs={24}>
                    <InputField
                        name="bankLegalAddress"
                        label={i18n.t('modals.modalCreateNewLegalEntity.fields.bankAddress.title')}
                        title={i18n.t('modals.modalCreateNewLegalEntity.fields.bankAddress.title')}
                        required={true}
                        value={stepFields.bankLegalAddress}
                        setValue={(value) => {
                            setFields({ ...stepFields, bankLegalAddress: value });
                        }}
                        getFieldErrors={getFieldErrors}
                    />
                </Col>
            </Row>

            <span className="divider-label">{i18n.t('modals.modalCreateNewLegalEntity.divider.correspondentBank')}</span>
            <DividerBlock style={dividerStyle} />

            <Row gutter={[{ xs: 0, sm: 0, md: 16}, 24]}>
                <Col lg={8} md={8} sm={24} xs={24}>
                    <InputField
                        name="correspondentBankName"
                        title={i18n.t('modals.modalCreateNewLegalEntity.fields.correspondentBankName.title')}
                        label={i18n.t('modals.modalCreateNewLegalEntity.fields.correspondentBankName.title')}
                        required={true}
                        value={stepFields.correspondentBankName}
                        setValue={(value) => {
                            setFields({ ...stepFields, correspondentBankName: value });
                        }}
                        getFieldErrors={getFieldErrors}
                    />
                </Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                    <InputField
                        name="correspondentBankInn"
                        title={i18n.t('modals.modalCreateNewLegalEntity.fields.correspondentBankInn.title')}
                        label={i18n.t('modals.modalCreateNewLegalEntity.fields.correspondentBankInn.title')}
                        required={true}
                        value={stepFields.correspondentBankInn}
                        setValue={(value) => {
                            setFields({ ...stepFields, correspondentBankInn: value });
                        }}
                        getFieldErrors={getFieldErrors}
                    />
                </Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                    <InputField
                        name="correspondentBankBic"
                        label={i18n.t('modals.modalCreateNewLegalEntity.fields.correspondentBankBic.title')}
                        title={i18n.t('modals.modalCreateNewLegalEntity.fields.correspondentBankBic.title')}
                        required={true}
                        value={stepFields.correspondentBankBic}
                        setValue={(value) => {
                            setFields({ ...stepFields, correspondentBankBic: value });
                        }}
                        getFieldErrors={getFieldErrors}
                    />
                </Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                    <InputField
                        name="correspondentBankAccount"
                        label={i18n.t('modals.modalCreateNewLegalEntity.fields.correspondentBankAccount.title')}
                        title={i18n.t('modals.modalCreateNewLegalEntity.fields.correspondentBankAccount.title')}
                        required={true}
                        value={stepFields.correspondentBankAccount}
                        setValue={(value) => {
                            setFields({ ...stepFields, correspondentBankAccount: value });
                        }}
                        getFieldErrors={getFieldErrors}
                    />
                </Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                    <InputField
                        name="correspondentBankCheckingAccount"
                        label={i18n.t('modals.modalCreateNewLegalEntity.fields.correspondentBankCheckingAccount.title')}
                        title={i18n.t('modals.modalCreateNewLegalEntity.fields.correspondentBankCheckingAccount.title')}
                        required={true}
                        value={stepFields.correspondentBankCheckingAccount}
                        setValue={(value) => {
                            setFields({ ...stepFields, correspondentBankCheckingAccount: value });
                        }}
                        getFieldErrors={getFieldErrors}
                    />
                </Col>
                <Col lg={24} md={24} sm={24} xs={24}>
                    <InputField
                        name="correspondentBankLegalAddress"
                        label={i18n.t('modals.modalCreateNewLegalEntity.fields.correspondentBankLegalAddress.title')}
                        title={i18n.t('modals.modalCreateNewLegalEntity.fields.correspondentBankLegalAddress.title')}
                        required={true}
                        value={stepFields.correspondentBankLegalAddress}
                        setValue={(value) => {
                            setFields({ ...stepFields, correspondentBankLegalAddress: value });
                        }}
                        getFieldErrors={getFieldErrors}
                    />
                </Col>
            </Row>

            <span className="divider-label">{i18n.t('modals.modalCreateNewLegalEntity.divider.info')}</span>
            <DividerBlock style={dividerStyle} />

            <Row gutter={[{ xs: 0, sm: 0, md: 16}, 24]}>
                <Col lg={8} md={8} sm={24} xs={24}>
                    <InputField
                        name="phone"
                        title={i18n.t('modals.modalCreateNewLegalEntity.fields.phoneMobile.title')}
                        label={i18n.t('modals.modalCreateNewLegalEntity.fields.phoneMobile.title')}
                        required={true}
                        value={stepFields.phone}
                        setValue={(value) => {
                            setFields({ ...stepFields, phone: value });
                        }}
                        getFieldErrors={getFieldErrors}
                    />
                </Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                    <InputField
                        name="email"
                        label={i18n.t('modals.modalCreateNewLegalEntity.fields.email.title')}
                        required={true}
                        value={stepFields.email}
                        setValue={(value) => {
                            setFields({ ...stepFields, email: value });
                        }}
                        getFieldErrors={getFieldErrors}
                    />
                </Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                    <InputField
                        name="atiCode"
                        label={i18n.t('modals.modalCreateNewLegalEntity.fields.atiCode.title')}
                        isDisabled={notRegisteredATI}
                        required={true}
                        value={stepFields.atiCode}
                        setValue={(value) => {
                            setFields({ ...stepFields, atiCode: value });
                        }}
                        getFieldErrors={getFieldErrors}
                    />
                    <Checkbox
                        name="notRegisteredATI"
                        checked={notRegisteredATI}
                        onChange={(e) => {
                            setFields({
                                ...stepFields,
                                atiCode: e.target.checked ? i18n.t('modals.modalCreateNewLegalEntity.fields.noAtiCode.title') : "",
                            });
                            setNotRegisteredATI(e.target.checked);
                        }}
                        style={{ fontSize: "10pt", paddingTop: "15px" }}
                    >
                      {i18n.t('modals.modalCreateNewLegalEntity.fields.notRegisteredATI.title')}
                    </Checkbox>
                </Col>
            </Row>
          {renderAdditionalRequisites()}
        </>
    );
}
